import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import { Button, TextField, FormControl, Select, MenuItem, Backdrop } from "@material-ui/core";
import Spacer from "../../../components/Spacer";
import MainContainer from "../../../components/MainContainer";
import { headerDataRH } from "../../../data/modules/hr-header";
import { useNavigate } from 'react-router-dom';
import TimeTrackingService from "../../../services/TimeTrackingService";
import Title from "../../../components/Title";
import { CircularProgress } from "@material-ui/core";
import { DataGrid } from "@material-ui/data-grid";
import { CreateTwoTone, DeleteOutlineRounded } from "@material-ui/icons";
import Message from "../../tools/Message";
import CheckIcon from "@material-ui/icons/Send";
import { useCallback } from 'react';

const useStyles = makeStyles((theme) => ({
    paper: {
        padding: theme.spacing(2),
        display: "flex",
        overflow: "auto",
        flexDirection: "column",
        elevation: 0,
    },
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff',
    },
}));

export default function TimeTrackingProvisional(props) {
    const classes = useStyles();
    const navigate = useNavigate();
    const [list, setList] = useState([]);
    const [isloading, setIsloading] = useState(false);
    const [message, setMessage] = useState({
        open: false,
        color: 'green',
        messageInfo: '',
    });
    const { open, color, messageInfo } = message;

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = () => {
        setIsloading(true);
        TimeTrackingService.getTimePrevisionaly().then((results) => {
            if (results) {
                  const uniqueData = Array.from(
                    new Map(
                        results.data.map(item => [item.timetraking_id, item])
                    ).values()
                );
                const rowsWithIds = uniqueData.map((item) => ({
                    ...item,
                    id: item.timetraking_id,
                }));

                setList(rowsWithIds);
            } else {
                setList([]);
            }
            setIsloading(false);
        }).catch(() => {
            setIsloading(false);
        });
    }

    function handleClick() {
        navigate('/timeTrackingAdd');
    }

    const handleenvoie = useCallback((id) => {
        setIsloading(true);
        TimeTrackingService.sendvalidate(id).then((results) => {
            if (results) {
                setMessage({ ...message, open: true, color: 'green', messageInfo: results.message });
                fetchData();
            } else {
                setMessage({ ...message, open: true, color: 'red', messageInfo: results.message });
                setIsloading(false);
            }
        });
    }, []);

    const handleEdit = useCallback((id) => {
        navigate('/timeTrackingAdd/' + id);
    }, []);

    const handleDelete = useCallback((id) => {
        setIsloading(true);
        TimeTrackingService.deleteTimePrevisionaly(id).then((results) => {
            if (results) {
                setMessage({ ...message, open: true, color: 'green', messageInfo: results.message });
                fetchData();
            } else {
                setMessage({ ...message, open: true, color: 'red', messageInfo: results.message });
                setIsloading(false);
            }
        });
    }, []);

    const column = [
        // ✅ ACTION EN PREMIÈRE POSITION
        {
            field: "actions",
            headerName: "Action",
            width: 240,
            renderCell: (params) => {
                return (
                    <div>
                        {params.row.validate === "Nouveau" && (
                            <>
                                <Button
                                    title="Envoyez pour validation"
                                    onClick={() => handleenvoie(params.row.id)}
                                    sx={{ minWidth: 'auto' }}
                                >
                                    <CheckIcon style={{ color: "green" }} />
                                </Button>
                                <Button 
                                    onClick={() => handleEdit(params.row.id)}
                                    sx={{ minWidth: 'auto' }}
                                >
                                    <CreateTwoTone style={{ color: "black" }} />
                                </Button>
                                <Button 
                                    onClick={() => handleDelete(params.row.id)}
                                    sx={{ minWidth: 'auto' }}
                                >
                                    <DeleteOutlineRounded style={{ color: "red" }} />
                                </Button>
                            </>
                        )}
                    </div>
                );
            },
        },
        // ✅ STATUT JUSTE APRÈS ACTION
        {
            field: "validate",
            headerName: "Statut",
            width: 150,
            renderCell: (params) => (
                <span style={{
                    fontWeight: "bold"
                }}>
                    {params.value}
                </span>
            )
        },
        {
            field: "name",
            headerName: "Nom et prénom(s)",
            width: 300
        },
        {
            field: "date",
            headerName: "Date du pointage",
            width: 200,
        },
        {
            field: "morning",
            headerName: "Periode",
            width: 200,
            valueGetter: (params) => {
                const entry = (params.row.timetracking_entree === "Non défini") ? "" : "Entrée";
                const sortie = (params.row.timetracking_sortieap === "Non défini") ? "" : "Sortie";

                if (entry && sortie) {
                    return `${entry} - ${sortie}`;
                } else if (entry) {
                    return entry;
                } else if (sortie) {
                    return sortie;
                } else {
                    return "";
                }
            },
        },
        {
            field: "observation",
            headerName: "Motif",
            width: 350,
        },
    ];

    function handleCloseMessage() {
        setMessage({ ...message, open: false });
    }

    return (
        <MainContainer {...headerDataRH}>
            {/* <Backdrop className={classes.backdrop} open={isloading}>
                <CircularProgress color="inherit" />
            </Backdrop> */}
            <Message open={open} color={color} messageInfo={messageInfo} handleClose={handleCloseMessage} />
            <Grid container spacing={3}>
                <Button
                    variant="contained"
                    color="secondary"
                    onClick={handleClick}
                    style={{ fontWeight: 600 }}
                >
                    CREER
                </Button>
            </Grid>
            <h1 style={{ textAlign: 'center', color: '#4682B4' }}>Liste des pointages manuels</h1>
            <Spacer y={2} />
            <Grid item xs={12}>
                <DataGrid
                    rows={list}
                    columns={column}
                    pageSize={10}
                    rowsPerPageOptions={[10]}
                    disableSelectionOnClick
                    style={{ width: "100%", height: 500 }}
                    loading={isloading}
                />
            </Grid>
        </MainContainer>
    );
}